// Description: Page that will render the initial step of the form that will create a list with one integration
// Updated: 25/06/2025
// Author: Simon Franklin

// React
import React, { useEffect } from 'react'

// Material UI Components
import { Box, Skeleton, Typography, Button } from '@mui/material';

// Components and functions for the project
import { useNavigate, useParams } from 'react-router-dom';
import use123zapStore from '../../context/123zapStore';
import { consultIntegrations } from '../../api/aws/Integrations/listIntegrations';
import HeaderPage from '../../components/HeaderPage/HeaderPage';

// Render The Page
const PageAddIntegration = () => {
    const { integration } = useParams();
    const planoAtual = use123zapStore((state) => state.planoAtual);
    const integrations = use123zapStore((state) => state.integrations);
    const setIntegrations = use123zapStore((state) => state.setIntegrations);
    const alreadyFetchIntegrations = use123zapStore((state) => state.alreadyFetchIntegrations);
    const setAlreadyFetchIntegrations = use123zapStore((state) => state.setAlreadyFetchIntegrations);
    const [loading, setLoading] = React.useState(false);

    useEffect(() => {
        if (
            planoAtual !== 'FreeZap' &&
            planoAtual !== 'StartZap' &&
            planoAtual !== 'ProZap' &&
            planoAtual !== 'UltraZap' &&
            planoAtual !== null
        ) {
            navigate('/acesso-restrito');
        }
    }, [planoAtual]);


    const findName = (name) => {
        if (name === "sgp") {
            return "SGP";
        } else if (name === "controllr") {
            return "Controllr ISP";
        } else if (name === "hubsoft") {
            return "HubSoft";
        } else if (name === "elitesoft") {
            return "EliteSoft";
        } else if (name === "sienge") {
            return "Sienge";
        }
    };
    const selectedIntegration = integrations.filter((item) => item.title === findName(integration))[0];

    React.useEffect(() => {
        (async () => {
            if (alreadyFetchIntegrations === false) {
                setLoading(true);
                consultIntegrations()
                    .then((response) => {
                        setIntegrations(response.data);
                        setAlreadyFetchIntegrations(true);
                    })
                    .finally(() => (setLoading(false)));
            }
        })();
    }, []);

    const navigate = useNavigate();

    return (
        <Box component="main" sx={{ display: "flex", flexDirection: "column" }}>
            <HeaderPage />
            <Box
                sx={{
                    display: "flex",
                    padding: "32px",
                    gap: "64px",
                    minHeight: "calc(100vh - 100px)",
                    flexDirection: "column"
                }}
            >
                <Box component="section">
                    {
                        loading === false && integrations.length > 0 && selectedIntegration !== null && typeof selectedIntegration === 'object' ? (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: { xs: "100%", sm: "494.25px" },
                                    height: "auto",
                                    borderRadius: "4px",
                                    border: "1px solid #E0E0E0",
                                    padding: "24px",
                                    backgroundColor: "#fff",
                                    gap: "24px",
                                }}
                            >
                                <Box
                                    component="img"
                                    src={selectedIntegration.logo}
                                    alt={`logo ${selectedIntegration.title}`}
                                    sx={{
                                        width: "32px",
                                        height: "32px",
                                        borderRadius: "4px",
                                        backgroundColor: "#bdbdbd",
                                        minWidth: "32px",
                                        minHeight: "32px",
                                    }}
                                />
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "12px",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: { xs: "13px", sm: "16px" },
                                        }}
                                    >
                                        {selectedIntegration.title}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: 400,
                                            fontSize: { xs: "12px", sm: "16px" },
                                        }}
                                    >
                                        {selectedIntegration.description}
                                    </Typography>
                                </Box>
                            </Box>
                        ) : (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: { xs: "100%", sm: "494.25px" },
                                    height: "220px",
                                    borderRadius: "4px",
                                    border: "1px solid #E0E0E0",
                                    padding: "24px",
                                    backgroundColor: "#fff",
                                    gap: "24px",
                                }}
                            >
                                <Skeleton
                                    variant="rectangular"
                                    width={32}
                                    height={32}
                                    sx={{ borderRadius: "4px" }}
                                />
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "12px",
                                    }}
                                >
                                    <Skeleton
                                        variant="text"
                                        sx={{ fontSize: { xs: "13px", sm: "16px" }, width: "50px" }}
                                    />
                                    <Box>
                                        <Skeleton variant="text" sx={{ fontSize: { xs: "13px", sm: "16px" } }} />
                                        <Skeleton variant="text" sx={{ fontSize: { xs: "13px", sm: "16px" } }} />
                                        <Skeleton variant="text" sx={{ fontSize: { xs: "13px", sm: "16px" } }} />
                                    </Box>
                                </Box>
                            </Box>
                        )
                    }
                </Box>
                <Box component="section" sx={{ display: "flex", flexDirection: "column", gap: "64px" }}>
                    <Typography sx={{ color: "#848484", fontSize: { xs: "18px", sm: "24px" }, fontWeight: 500 }}>
                        Escolha o tipo de listagem
                    </Typography>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: "32px" }}>
                        <Button onClick={() => navigate("faturas em aberto")} variant="contained" sx={{ height: "54px", borderRadius: "6px", width: { xs: "100%", sm: "400px" } }}>
                            Faturas em aberto
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default PageAddIntegration